import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group 1538231751" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M2 16.9948L5.9987 8.9974L2 1",
        stroke: "white",
        "stroke-width": "2.99902",
        "stroke-miterlimit": "10"
      }),
      _createElementVNode("path", {
        id: "Vector_2",
        d: "M10 16.9948L13.9987 8.9974L10 1",
        stroke: "white",
        "stroke-width": "2.99902",
        "stroke-miterlimit": "10"
      })
    ], -1)
  ]))]))
}
export default { render: render }